module.exports = __webpack_public_path__ + "img/az.7a3279e2.svg";